import BotOpsHealthPanel from "./botOpsHealthPanel";

const KillToggleCard = ({ title, descriptionOn, descriptionOff, enabled, loading, onToggle }) => (
    <section
        className={`rounded-lg border p-4 transition-colors ${
            enabled ? "border-green-600/50 bg-green-950/20" : "border-red-500/50 bg-red-950/20"
        }`}
    >
        <div className="flex flex-wrap items-center justify-between gap-4">
            <div>
                <p className="font-medium text-white">{title}</p>
                <p className="text-sm text-gray-400 mt-0.5">{enabled ? descriptionOn : descriptionOff}</p>
            </div>
            <label
                className={`flex items-center gap-2 cursor-pointer shrink-0 px-3 py-1.5 rounded-md border text-sm font-medium ${
                    enabled
                        ? "border-green-600/60 bg-green-900/30 text-green-300"
                        : "border-red-500/60 bg-red-900/30 text-red-300"
                }`}
            >
                <input
                    type="checkbox"
                    checked={enabled}
                    disabled={loading}
                    onChange={onToggle}
                    className="h-4 w-4 accent-[#d59106]"
                />
                <span>{enabled ? "Ativo" : "Desligado"}</span>
            </label>
        </div>
    </section>
);

const BotOpsOperarPanel = ({
    enabled,
    sandboxEnabled,
    killLoading,
    sandboxKillLoading,
    onKillToggle,
    onSandboxKillToggle,
    token,
    onAfterMutation,
    activeVersion,
}) => {
    return (
        <div className="flex flex-col gap-4 mb-6">
            <KillToggleCard
                title="Produção (clientes reais)"
                descriptionOn="Bot respondendo clientes"
                descriptionOff="Kill switch ativo — sem turno IA; fila Triagem"
                enabled={enabled}
                loading={killLoading}
                onToggle={onKillToggle}
            />

            <KillToggleCard
                title="Sandbox (chat e testes)"
                descriptionOn="Chat e testes com turno IA"
                descriptionOff="Sandbox desligado — chat de teste sem turno IA (sem Triagem)"
                enabled={sandboxEnabled}
                loading={sandboxKillLoading}
                onToggle={onSandboxKillToggle}
            />

            <BotOpsHealthPanel
                token={token}
                onAfterMutation={onAfterMutation}
                activeVersion={activeVersion}
            />
        </div>
    );
};

export default BotOpsOperarPanel;
